import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import utils from './utils';
import './element-ui';
import './styles/index.less';
import './styles/element-variables.less';
import './styles/transition.less';
import moment from 'moment';
import echarts from 'echarts';
import './directive';
import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import TreeSelect, { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Emit } from './emit/Emit';

import { getPermissions } from '@/api/role';

moment.locale('zh-cn', {
  weekdaysShort: [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ],
});
Vue.prototype.$utils = utils;
Vue.prototype.$moment = moment;
Vue.prototype.$echarts = echarts;
Vue.prototype.$baseURL = request.defaults.baseURL;
Vue.config.productionTip = false;
Vue.prototype.Emit = Emit;

//角色全局变量设置
Vue.prototype.user_role_admin = 1; //系统管理员
Vue.prototype.user_role_rent = 2; //租赁公司用户
Vue.prototype.user_role_proc = 3; //生产用户
Vue.prototype.user_role_data = 4; //数据用户
Vue.prototype.user_role_personal = 5; //个人用户
Vue.prototype.user_role_four = 6; //4S店用户
Vue.prototype.user_role_defind = 7; //自定义服务部门用户

//引入树形下拉组件
Vue.prototype.$LOAD_CHILDREN_OPTIONS = LOAD_CHILDREN_OPTIONS;
Vue.component('TreeSelect', TreeSelect);
router.beforeEach((to, from, next) => {
  if (to.path === '/user/index' || to.path === '/authority/index') {
    to.meta.keepAlive = true;
  } else {
    to.meta.keepAlive = false;
  }
  const token = getToken();
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (token) {
      // 通过vuex state获取当前的token是否存在
      if (store.state.home.permission.length > 0) {
        next();
      } else {
        if (store.state.home.RoleId) {
          let params = {
            roleId: store.state.home.RoleId,
          };
          if (JSON.parse(localStorage.getItem('user')).level === 2) {
            params.isHide = 1;
          }
          getPermissions(params).then((res) => {
            store.commit('home/Permission', res.data);

            let permission = res.data;
            let list = [];
            permission.map((menu) => {
              menu.permissions.map((per) => {
                if (per.annotation === '查看' && per.status === 1) {
                  let menus = menu.menuName.split('-');
                  list.push(menus[0]);
                }
              });
            });
            const routes = router.options.routes;
            const _routes = [];
            routes.forEach((element) => {
              const hidden = element['hidden'];
              const title = element['meta'] && element['meta']['title'];
              if (list.indexOf(title) >= 0) {
                _routes.push(element);
              }
            });
            let flag = false;
            _routes.map((item) => {
              if (to.path === item.path) {
                flag = true;
              }
            });
            if (flag) {
              next();
            } else {
              next({ path: _routes[0].path });
            }
          });
        } else {
          next({ name: 'Login' });
        }
      }
    } else {
      next({ name: 'Login' });
    }
  } else {
    next();
  }
});

Vue.filter('dateYMDHMSFormat', function(
  dateStr,
  pattern = 'YYYY-MM-DD HH:mm:ss'
) {
  return moment(dateStr).format(pattern);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
